import { useState, useEffect } from "react";
import Axios from "axios";
import { useBaseUrl } from "../ApiContext";

const useUnCompleted = (userToken) => {
  const baseUrl = useBaseUrl();
  const [dietForms, setDietForms] = useState(null);
  const [exerciseForms, setExerciseForms] = useState(null);

  useEffect(() => {
    const fetchUnCompleted = async () => {
      try {
        const response = await Axios.get(
          `${baseUrl}/payment/uncompleted`,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        setDietForms(response.data.diet);
        setExerciseForms(response.data.exercise);
      } catch (error) {
        console.log("Error during geting current weekly report", error);
      }
    };
    if (userToken) {
      fetchUnCompleted();
    }
  }, [baseUrl, userToken]);
  return { dietForms, exerciseForms };
};

export default useUnCompleted;
